import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter } from 'react-router-dom';
import App from './App';
import './css/App.css';
import './css/dialogs.css';
import './css/cards.css';
import './css/contact.css';
  
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>

    <BrowserRouter>
      <App/>
    </BrowserRouter>

  </React.StrictMode>
);